import React, {Component} from 'react'
import { observer } from 'mobx-react'
import liqpayGeneratorStore from "../../store/LiqpayGeneratorStore";
import {LQ_STEPS, LQ_STEPS_TITLE} from "../../config/constants";

@observer
class LiqpayHeader extends Component {
    render() {
        const step = LQ_STEPS.indexOf(liqpayGeneratorStore.step) + 1;
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-12 offset-0 col-md-6 offset-md-3'>
                        <header>
                            <div>
                                { liqpayGeneratorStore.step !== 'link' &&
                                    <div className='back-button' onClick={() => liqpayGeneratorStore.goBack()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                                             className="bi bi-arrow-left" viewBox="0 0 16 16">
                                            <path fillRule="evenodd"
                                                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
                                        </svg>
                                    </div>
                                }
                                { liqpayGeneratorStore.step === 'link' &&
                                    <div className='back-button' onClick={() => window.Telegram.WebApp.close()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                             fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                            <path
                                                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                                        </svg>
                                    </div>
                                }
                            </div>
                            <div className='step'>
                                <div className='step-num'>{step}/{LQ_STEPS.length}</div>
                                <div className='step-title'>{liqpayGeneratorStore.getCurrentStepTitle()}</div>
                            </div>
                        </header>
                    </div>
                </div>
            </div>
        )
    }
}

export default LiqpayHeader
